import type { ID } from '@octopus-do/octopus-project-core'
import { setMessageViewed } from '@storeOld/reducers/auth'
import { call, put } from 'redux-saga/effects'

import Api from '@/api'
import type { MessagesActions } from '../actions'

const fetchViewed = (id: ID) => {
  Api.Messages.viewed({ id })
    .then(() => {})
    .catch((err) => {
      console.error(err)
    })
}

export function* viewed({
  payload: { id },
}: ReturnType<typeof MessagesActions.viewed>) {
  yield call(fetchViewed, id)

  yield put(setMessageViewed(id))
}
